<template>
    <div class="VehicleEditPage">
        <DashboardSectionHeader title="Vehicle edit">
            <Button to="/company/vehicles" class="link primary">Cancel</Button>
            <Button class="primary" @click="handleSave" :disabled="submitPending">Save</Button>
        </DashboardSectionHeader>

        <VehicleForm
            ref="vehicleForm"
            v-if="vehicle"
            v-bind.sync="vehicle"
            :isEditMode="true"
        />

        <DashboardSectionHeader>
            <Button to="/company/vehicles" class="link primary">Cancel</Button>
            <Button class="primary" @click="handleSave" :disabled="submitPending">Save</Button>
        </DashboardSectionHeader>
    </div>
</template>

<script>
import * as api from '@/api';
import { cloneDeep } from 'lodash';
import createPatch from '@/utils/createPatch';
import DashboardSectionHeader from '@/components/DashboardSectionHeader';
import DashboardEditSection from '@/components/DashboardEditSection';
import VehicleForm from './components/VehicleForm';

export default {
    name: 'VehicleEditPage',

    components: {
        DashboardSectionHeader,
        DashboardEditSection,
        VehicleForm,
    },

    data: () => ({
        vehicleRef: null,
        vehicle: null,

        fetchPending: false,
        fetchError: null,
        submitPending: false,
        submitError: null,
    }),

    computed: {
        id() {
            return this.$route.params.id;
        },
    },

    watch: {
        id() {
            this.fetchVehicle();
        },
    },

    mounted() {
        this.fetchVehicle();
    },

    methods: {
        async fetchVehicle() {
            this.fetchPending = true;
            const res = await api.getVehicle(this.id);
            this.fetchPending = false;

            if (res.error) {
                this.fetchError = res.error;
                return this.$awn.alert('Failed to fetch vehicle');
            }

            this.setVehicle(res.body);
        },

        async handleSave() {
            if (!this.$refs.vehicleForm.validate()) {
                return;
            }

            this.submitPending = true;
            const res = await api.updateVehicle(createPatch(this.vehicleRef, this.vehicle));
            this.submitPending = false;

            if (res.error) {
                this.fetchError = res.error;
                return this.$awn.alert('Failed to update vehicle');
            }

            this.setVehicle(res.body);
            this.$awn.success('Vehicle has been updated!');
        },

        setVehicle(vehicle) {
            delete vehicle.company;

            this.vehicleRef = cloneDeep(vehicle);
            this.vehicle = vehicle;
        },
    },
}
</script>
